<div class="flex h-full flex-col overflow-hidden bg-white md:p-8">
    <div
        class="sr-app-light:visible vl-app-light:visible border-b border-solid border-opacity-10 bg-[var(--color-panel)] py-2 dark:border-contrast-yellow md:invisible">
        <div class="flex flex-row items-center justify-between">
            <ion-button [attr.aria-label]="'LOCAL_BTN_BACK' | translate" (click)="handleBackClicked()" fill="clear">
                <ion-icon
                    class="mr-1 text-xl dark:filter-yellow"
                    src="{{ assetsPath$ | async }}/img/journey-planner/icon-arrow.svg">
                </ion-icon>
            </ion-button>
            <h1 class="text-base font-bold leading-5">
                {{ 'MESSAGES' | translate }}
            </h1>
            <div class="w-14"></div>
        </div>
    </div>
    <div class="block--wrap block flex-1 overflow-y-auto" #containerElement>
        <div class="messages-list">
            <a
                class="messages-list-item grid grid-rows-[20%_65%_15%] place-items-start"
                #messageItem
                *ngFor="let message of messagesList"
                [id]="'message-' + message.id"
                [class.unread]="!message.isRead"
                [routerLink]="'/account/messages/' + message.id | localize"
                [queryParams]="message"
                [skipLocationChange]="true"
                (click)="onMessageClick()">
                <div class="ellipsis text-base font-bold text-black dark:text-contrast-yellow">
                    {{ message.subject }}
                </div>
                <div class="w-90 multiline-ellipsis pb-1 text-base text-black dark:text-contrast-yellow">
                    {{ message.body }}
                </div>
                <div class="mt-auto pb-1 text-xs text-gray-500 dark:text-contrast-yellow">
                    {{ 'PUBLISHED' | translate }}&nbsp;
                    {{ message.sendAt | formatTimeZone: DATE_TIME_FORMAT : TIMEZONE }}
                </div>
                <div class="abs-arrow">
                    <ion-icon
                        class="mr-1 text-xl text-gray-500 dark:filter-yellow"
                        name="chevron-forward-outline"></ion-icon>
                </div>
            </a>
            <ridango-ui-basic-loading-spinner *ngIf="loading"> </ridango-ui-basic-loading-spinner>
            <div
                class="flex flex-col items-center justify-center gap-3 p-12 text-center"
                *ngIf="!loading && allMessagesLoaded && messagesList.length === 0">
                <ion-icon
                    class="text-6xl text-gray-300 dark:text-contrast-yellow"
                    name="mail-open-outline"
                    aria-hidden="true">
                </ion-icon>
                <p class="text-base font-semibold text-gray-500 dark:text-contrast-yellow">
                    {{ 'NO_NEW_MESSAGES' | translate }}
                </p>
            </div>
        </div>
    </div>
</div>
